module.exports = __webpack_public_path__ + "icon_laakari.d859b3f1f56561cede5f.svg";